import TranslationUtils from '@gik/core/utils/TranslationUtils';

const blockName = 'calendar-empty-view';

const translations = {
  OrganizerViewLeadText: 'Only you as an <mark>organizer</mark> can add requests to this calendar.',
  OrganizerViewText: 'Add as many requests as you want to be claimed by your supporters.',
  OrganizerViewFooter: 'You can turn this calendar off in your page settings above.',
  NonOrganizerText1: 'This calendar has no upcoming events',
  NonOrganizerText2: 'Check back soon to see if there are new ways you can help',
};

export default {
  [blockName]: translations,
};

export const translationKeys: typeof translations = TranslationUtils.mapKeys(blockName, translations);
